import styled, { css } from 'styled-components';

import { basic } from '../../theme/colors';

export const TabsContainer = styled.div<{ manualJustify?: boolean }>`
  background: white;
  width: 100%;
  border: solid 1px ${basic.haydenBorderSecond};
  font-size: 14px;

  .nav-tabs .nav-link {
    // TODO - it's fallback. Delete if you're sure everything looks good.
    ${({ manualJustify }) =>
      manualJustify &&
      css`
        width: 100%;
        max-width: 50%;
        max-width: calc(100% / 2);
      `}

    background: #f7f7f7;
    border-radius: 0;
    text-align: center;
    font-weight: 600;
    color: black;
    transition: 300ms linear background;
    border-right: solid 1px #e7e7e7;
    border-bottom: solid 1px #e7e7e7;

    &:last-of-type {
      border-right: 0 !important;
    }

    &:active,
    &:hover,
    &:focus {
      outline: none;
      border-right: solid 1px #e7e7e7;
      border-bottom: solid 1px #e7e7e7;
      box-shadow: none;
    }

    &.active {
      background: white;
      border: 0;
    }
  }

  .nav-tabs .nav-item {
    width: 100%;
    max-width: 50%;
    max-width: calc(100% / 2);
  }

  .nav-tabs a.nav-link {
    max-width: 100%;
    width: auto;
  }

  .tab-pane {
    padding: 6%;
    font-weight: 300;
    line-height: 1;

    table td:first-of-type {
      width: 50%;
    }

    table td:nth-of-type(2) {
      padding-left: 0;
    }
  }

  table tr td {
    padding-top: 1em;
    padding-bottom: 1em;
  }

  table tr td:nth-of-type(2) {
    font-weight: 600;
  }
`;
